import React, { useRef, useState, useEffect } from 'react';

import BayTooltip from '../../BayTooltip';

interface TruncatedDescriptionProps {
	eventName?: string;
	type?: string;
	style?: string;
	mouseEnterDelay?: number;
	[key: string]: any; // Forward any additional props to BayTooltip for customization
}

const TruncatedDescription: React.FC<TruncatedDescriptionProps> = ({
	eventName,
	type,
	style,
	mouseEnterDelay = 0.15,
	...tooltipProps
}) => {
	const descriptionRef = useRef<HTMLDivElement>(null);
	const [isEllipsisActive, setIsEllipsisActive] = useState(false);

	const checkEllipsis = () => {
		const descriptionDiv = descriptionRef?.current;
		if (descriptionDiv) {
			setIsEllipsisActive(
				descriptionDiv.scrollHeight > descriptionDiv.clientHeight ||
					descriptionDiv.scrollWidth > descriptionDiv.clientWidth,
			);
		}
	};

	useEffect(() => {
		checkEllipsis();
		const descriptionDiv = descriptionRef.current;
		if (!descriptionDiv) return;

		const observer = new ResizeObserver(() => checkEllipsis());
		observer.observe(descriptionDiv);

		return () => observer.disconnect();
	}, [eventName]);

	return (
		<>
			{isEllipsisActive ? (
				<BayTooltip
					mouseEnterDelay={mouseEnterDelay}
					overlay={eventName}
					placement="top"
					{...tooltipProps}
				>
					<div
						ref={descriptionRef}
						className={`${style} ${type !== 'taskTitle' && type !== 'description' ? 'mt-2' : ''}`}
					>
						{eventName}
					</div>
				</BayTooltip>
			) : (
				<div
					ref={descriptionRef}
					className={`${style} ${type !== 'taskTitle' && type !== 'description' ? 'mt-2' : ''}`}
				>
					{eventName}
				</div>
			)}
		</>
	);
};

export default TruncatedDescription;
